interface BlogPostSchemaProps {
  title: string;
  description: string;
  datePublished: string;
  dateModified?: string;
  author: {
    name: string;
    url?: string;
  };
  image?: string;
  url: string;
}

export function generateBlogPostSchema({
  title,
  description,
  datePublished,
  dateModified,
  author,
  image,
  url,
}: BlogPostSchemaProps) {
  return {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: title,
    description: description,
    author: {
      "@type": "Person",
      name: author.name,
      ...(author.url && { url: author.url }),
    },
    datePublished: datePublished,
    dateModified: dateModified || datePublished,
    image: image || "https://www.diyecohomes.com/images/default-blog-image.jpg", // Default blog image for schema
    publisher: {
      "@type": "Organization",
      name: "DIY Eco Homes",
      logo: {
        "@type": "ImageObject",
        url: "https://www.diyecohomes.com/images/logo.png", // Organization logo for schema
      },
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": url,
    },
  };
}

export function generateWebsiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "DIY Eco Homes",
    description: "Expert guidance on eco-friendly home improvements, sustainable living, and DIY projects for a greener future.",
    url: "https://www.diyecohomes.com",
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: "https://www.diyecohomes.com/search?q={search_term_string}",
      },
      "query-input": "required name=search_term_string",
    },
  };
} 